module.exports = __webpack_public_path__ + "static/media/DEFI5-ETH.38f68c60.png";